(function() {

	angular
		.module('ngmvac')
		.filter('acrissFilter', AcrissFilter);

	function AcrissFilter() {
		return function(cars) {
			var items = [];
			angular.forEach(cars, function(car, index){
				if(car.cAcriss != '')
					items.push(car.cAcriss);
			});

			var unique = items.filter(function(elem, index, self){
				return index === self.indexOf(elem);
			});

			return unique;
		}
	}

})();